export * from './src/premium-domains-v2-availability-domain-availability.universal.js';
